import React from "react";
import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import Logout from "./components/Logout/Logout";
import Home from "./pages/Home";
import BusinessProcessModel from "./pages/BusinessProcessModel";
import Administration from "./pages/Administration";
import BusinessProcessModelDetail from "./pages/BusinessProcessModelDetail";
import {SessionContext} from "./util/SessionContext";
import useAppContext from "./util/AppContext";
import AdministrationOrganization from "./pages/AdministrationOrganization";
import AdministrationPosition from "./pages/AdministrationPosition";
import AdministrationRole from "./pages/AdministrationRole";
import AdministrationUserGroup from "./pages/AdministrationUserGroup";
import AdministrationWorkGroup from "./pages/AdministrationWorkGroup";
import AdministrationEmployee from "./pages/AdministrationEmployee";

export default function AppRoutes() {
    const location = useLocation();

    const sessionContext:SessionContext = useAppContext()?.sessionContext!;
    const loggedIn = sessionContext.valid() && location.pathname !== "/logout";

    let content = (
        <Routes>
            <Route path="/" element={<BusinessProcessModel />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/administration" element={<Administration />} />
            <Route path="/administration/roles" element={<AdministrationRole />} />
            <Route path="/administration/organizations" element={<AdministrationOrganization />} />
            <Route path="/administration/positions" element={<AdministrationPosition />} />
            <Route path="/administration/usergroups" element={<AdministrationUserGroup />} />
            <Route path="/administration/workgroups" element={<AdministrationWorkGroup />} />
            <Route path="/administration/users" element={<AdministrationEmployee/>} />
            <Route path="/bpm" element={<BusinessProcessModel />} />
            <Route path="/bpm/bpm-detail" element={<BusinessProcessModelDetail />} />

            <Route path="/" element={<Navigate replace to="/bpm" />} />

            <Route path="/*" element={<Navigate to="/" replace state={{
                referrer: {
                    pathname: location.pathname,
                    search: location.search,
                },
            }} />} />
        </Routes>
    )

    if (!loggedIn) {
        content = (
            <Routes>
                <Route path="/logout" element={<Logout />} />
                <Route path="/*" element={<Home />} />
            </Routes>
        )
    }
    return (
        content
    );
}